import "./src/styles/global.css"

// 404 페이지 처리를 위한 라우터 설정
export const onRouteUpdate = ({ location, prevLocation }) => {
    // 개발 모드에서 404 페이지 디버깅
    if (process.env.NODE_ENV === 'development') {
        console.log('Route changed from', prevLocation?.pathname, 'to', location.pathname)
    }
}

// 클라이언트 사이드 라우팅에서 404 처리
export const onPreRouteUpdate = ({ location, prevLocation }) => {
    // 존재하지 않는 경로에 대한 처리
    if (typeof window !== 'undefined') {
        const validPaths = ['/', '/404/']
        const currentPath = location.pathname

        // 유효하지 않은 경로인 경우 404 페이지로 리다이렉트
        if (!validPaths.includes(currentPath) && !currentPath.startsWith('/#')) {
            // 개발 모드에서는 콘솔에 로그 출력
            if (process.env.NODE_ENV === 'development') {
                console.log('Invalid path detected:', currentPath)
            }
        }
    }
}